import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { AuthorizationService } from "@core/store/auth/authorization.service";

@Injectable()
export class SubscriptionGuard implements CanActivate {
  constructor(private authorizationService: AuthorizationService) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.authorizationService.isAuthorized();
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/guards/subscription.guard.ts